<template>
  <div id="login" class="container">
    <v-container>
      <v-row class="justify-center">
        <v-col cols="12" md="6">
          <v-card
            tile
            flat
            maxWidth="300"
            class="mx-auto p-5 mt-16 transparent"
            :class="$vuetify.breakpoint.mobile ? '' : 'pt-16'"
          >
            <!-- <div class="d-flex"> -->
            <!-- <v-img maxWidth="50" src="@/assets/logo.png"></v-img> -->
            <div class="text-h4 text-center font-weight-bold">Login</div>
            <!-- </div> -->

            <v-form
              ref="form"
              class="mt-16"
              v-model="valid"
              @submit.prevent="login()"
            >
              <v-text-field
                outlined
                v-model="email"
                :rules="emailRules"
                label="E-Mail"
                required
              ></v-text-field>
              <v-text-field
                outlined
                v-model="password"
                :rules="passwordRules"
                label="Passwort"
                type="password"
                required
              >
              </v-text-field>
              <vue-recaptcha
                v-if="$connection === 'https://www.tgschwalbach.de'"
                sitekey="6Lfz8ngaAAAAAMUQDARMQilxKnq3bvqeCZc2X0Ko"
                ref="recaptcha"
                @verify="onCaptchaVerified"
                @expired="onCaptchaExpired"
              ></vue-recaptcha>
              <v-btn
                tile
                v-if="$connection !== 'https://www.tgschwalbach.de'"
                @keydown.enter="login()"
                :disabled="!valid"
                type="submit"
                class="w-full mt-5"
                color="primary"
                large
                >Login</v-btn
              >   <v-btn
                tile
                v-if="$connection === 'https://www.tgschwalbach.de'"
                @keydown.enter="login()"
                :disabled="!valid || !verified"
                type="submit"
                class="w-full mt-5"
                color="primary"
                large
                >Login</v-btn
              >
            </v-form>
          </v-card>
          <router-link :to="{ name: 'ForgotPassword' }">
            <div class="text-center mt-8 primary--text">
              {{ $t("forgotPassword") }}?
            </div>
          </router-link>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import VueRecaptcha from "vue-recaptcha";
export default {
  components: { VueRecaptcha },
  name: "",
  data: () => ({
    valid: true,
    password: "",
    verified: false,
    token: "",
    passwordRules: [(v) => !!v || "Passwort wird benötigt"],
    email: "",
    emailRules: [
      (v) => !!v || "Email wird benötigt",
      (v) => /.+@.+\..+/.test(v) || "E-mail muss korrekt sein",
    ],
  }),
  methods: {
    async onCaptchaVerified(recaptchaToken) {
      try {
        this.verified = true;
        this.token = recaptchaToken;
      } catch (error) {
        return error;
      }
    },
    onCaptchaExpired: function () {
      this.$refs.recaptcha.reset();
    },
    async login() {
      try {
        if (this.valid)
          await this.$store.dispatch("user/login", {
            email: this.email,
            password: this.password,
            recaptchaToken: this.token,
          });
        this.$refs.recaptcha.reset();
        this.verified = false;
        this.token = "";
      } catch (e) {
        return e;
      }
    },
    validate() {
      this.$refs.form.validate();
      this.verified = false;
      this.token = "";
    },
    reset() {
      this.$refs.form.reset();
    },
    resetValidation() {
      this.$refs.form.resetValidation();
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
